import { UserAuthentication } from './actionTypes';

const initialState = {
    initial: true,
    isFetching: false,
    usersResponse: {},
};

const requestIsLoggedIn = (state) => {
    return {
        ...state,
        initial: false,
        isFetching: true,
    };
};

const receiveIsLoggedIn = (state, { usersResponse }) => {
    return {
        ...state,
        isFetching: false,
        usersResponse,
    };
};

export default function(state = initialState, action) {
    switch (action.type) {
        case UserAuthentication.REQUEST_IS_LOGGED_IN:
            return requestIsLoggedIn(state);
        case UserAuthentication.RECEIVE_IS_LOGGED_IN:
            return receiveIsLoggedIn(state, action);
    }
    return state;
}
